<template>
  <div>
    <el-row>
      <div style="padding: 10px 25px">
        <el-form ref="form" :model="form" :inline="true" style="padding: 10px">
          <el-form-item>
            <el-input
              v-model="form.package_no"
              placeholder="包裹号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.goods_no"
              placeholder="货号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.goods_kh"
              placeholder="款号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="form.sku"
              placeholder="SKU编号"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label-width="0">
            <el-button type="primary" @click="handleSearch"> 查询 </el-button>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button type="success" @click="handleListExport"
              >导出列表
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-row>
      <el-table
        v-if="listData.length > 0"
        :key="'table1'"
        v-loading="tableLoading"
        :data="listData"
        border
        max-height="400px"
      >
        <el-table-column prop="img" label="商品图片" align="center" width="90">
          <template #default="{ row }">
            <div
              v-viewer
              style="
                width: 60px;
                height: 60px;
                overflow: hidden;
                cursor: pointer;
              "
            >
              <img style="width: 160%; height: 160%" :src="row.main_img" />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="goods_name"
          label="商品名称"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="goods_no"
          label="货号"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="goods_kh"
          label="款号"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column prop="sku" label="SKU" align="center" width="160">
        </el-table-column>
        <el-table-column prop="co_val" label="颜色" align="center" width="110">
        </el-table-column>
        <el-table-column prop="si_val" label="尺码" align="center" width="110">
        </el-table-column>
        <el-table-column
          prop="package_no"
          label="包裹号"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="in_num"
          label="一手入库数（当前实时）"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="num"
          label="商家配货数"
          align="center"
          width="160"
        >
        </el-table-column>

        <el-table-column
          prop="check_goods_num"
          label="当前入库件数差异"
          align="center"
        >
          <template #default="{ row }">
            <NumColorCell :num="row.in_feedback_num || ''" />
          </template>
        </el-table-column>
      </el-table>

      <el-table
        v-if="listData.length > 0"
        :key="'table2'"
        v-loading="tableLoading"
        :data="totalData"
        border
        :show-header="false"
      >
        <el-table-column prop="" label="" align="center" width="90">
          合计
        </el-table-column>
        <el-table-column prop="" label="" align="center" width="160">
        </el-table-column>
        <el-table-column prop="" label="" align="center" width="160">
        </el-table-column>
        <el-table-column prop="" label="" align="center" width="160">
        </el-table-column>
        <el-table-column prop="" label="" align="center" width="160">
        </el-table-column>
        <el-table-column prop="" label="" align="center" width="110">
        </el-table-column>
        <el-table-column prop="" label="" align="center" width="110">
        </el-table-column>

        <el-table-column prop="" align="center" width="160"> </el-table-column>
        <el-table-column prop="in_num" align="center" width="160">
        </el-table-column>
        <el-table-column prop="num" align="center" width="160">
        </el-table-column>
        <el-table-column prop="in_feedback_num" align="center">
          <template #default="{ row }">
            <NumColorCell :num="row.in_feedback_num || ''" />
          </template>
        </el-table-column>
      </el-table>

      <div v-if="listData.length <= 0" class="flex-center">暂无数据～</div>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import NumColorCell from "@//pages/receiveGoods/StockVarianceProcess/components/NumColorCell.vue";

import { postSupplyFeedbackGapdGoodsList } from "@/openapi/erp/supplyPackageCheckRecord.js";

const SEARCH_OPTIONS = {
  CHECK_STATUS: [
    {
      value: 1,
      label: "待核对",
    },
    {
      value: 2,
      label: "已核对",
    },
  ],
  CHECK_RESULT: [
    {
      value: 1,
      label: "有差异",
    },
    {
      value: 2,
      label: "无差异",
    },
  ],
  PACKGE_STATUS: [
    {
      value: 1,
      label: "待接收",
    },
    {
      value: 2,
      label: "已接收",
    },
    {
      value: 3,
      label: "已点货",
    },
  ],
};
const FETCH_TYPE_MAP = {
  exportList: "1",
  showList: "0",
};

export default {
  name: "InventoryByGoods",
  components: {
    NumColorCell,
  },
  props: {
    formProps: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      FETCH_TYPE_MAP,
      SEARCH_OPTIONS,
      tableLoading: false,
      form: {
        package_no: "",
        goods_kh: "",
        goods_no: "",
        sku: "",
        check_status: "",
        check_result: "",
        package_time: this.formProps.package_time || "",
        supply_id: this.formProps.supply_id || "",
        package_type: this.formProps.package_type || "", // 包裹类型 "1"、大货 "2"、前置仓
      },
      listData: [],
      totalData: [],
    };
  },
  watch: {
    formProps: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.form.supply_id = newVal.supply_id || "";
        this.form.package_time = newVal.package_time || "";
        this.form.package_type = newVal.package_type || "";
        if (
          Boolean(this.form.supply_id) &&
          Boolean(this.form.package_time) &&
          Boolean(this.form.package_type)
        ) {
          this.fetchData("showList");
        }
      },
    },
  },
  methods: {
    async fetchData(fetchType) {
      try {
        if (fetchType === "exportList") {
          this.form.export = FETCH_TYPE_MAP[fetchType];
        } else {
          delete this.form.export;
        }
        const showLoading = fetchType === "showList";
        if (showLoading) {
          this.tableLoading = true;
        }
        const res = await postSupplyFeedbackGapdGoodsList(this.form);
        if (showLoading) {
          this.listData = res.list || [];
          this.totalData = [res.statics] || [];
          this.tableLoading = false;
        } else {
          window.open(apiBaseURL + res.file);
        }
      } catch (err) {
        console.log("postGetList err: ", err);
        this.tableLoading = false;
      }
    },
    handleSearch() {
      this.fetchData("showList");
    },
    handleListExport() {
      this.fetchData("exportList");
    },
  },
};
</script>

<style scoped>
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/receiveGoods/StockVarianceProcess/components/InventoryByLackGoods.vue